import React from "react";

import {
  useMiddleware,
  EmitFunction,
} from "@piqnt/runtime-core/react/ReactMount";
import { SpaceContext } from "../space";

import { getLabel } from "@piqnt/runtime-core/common/Label";
import { getKey, type PlainFixture } from "@piqnt/runtime-space/drawing-model";

interface LiveFixtureComponentProps {
  emit: EmitFunction;
  fixture: PlainFixture;
  selected: boolean;
  selectable?: boolean;
}

class LiveFixtureComponent extends React.PureComponent<LiveFixtureComponentProps> {
  handleClick = () => {
    const { emit, fixture } = this.props;
    emit("select-fixture", {
      fixture: getKey(fixture),
      body: getKey(fixture.__temp__body),
    });
  };

  render() {
    const { fixture, selected, selectable } = this.props;
    if (!fixture) {
      return null;
    }
    const label = getLabel(fixture);
    let className = "";
    className += selected ? "selected-item " : "";
    className += selectable ? "clickable " : "";
    return (
      <span
        className={className}
        onClick={selectable ? this.handleClick : null}
      >
        {label ? "fixture#" + label : (fixture.shape?.type ?? "")}
      </span>
    );
  }
}

interface LiveFixtureProps {
  fixture: PlainFixture;
  selectable?: boolean;
}

export const LiveFixture = (props: LiveFixtureProps) => {
  const { context, emit } = useMiddleware<SpaceContext>();
  const fixtureKey = getKey(props.fixture);
  const selected = !!context.multiselect.value.findKey(fixtureKey);

  return (
    <LiveFixtureComponent
      fixture={props.fixture}
      selectable={props.selectable}
      emit={emit}
      selected={selected}
    />
  );
};
